import { ApiCallState } from '../constants/other';
export const createActionType = (actionType) => ({
    NAME: actionType,
    REQUEST: `${actionType}_${ApiCallState.request}`,
    SUCCESS: `${actionType}_${ApiCallState.success}`,
    ERROR: `${actionType}_${ApiCallState.error}`,
});
export default createActionType;
